import { faBuilding, faFileCircleCheck, faFileCircleMinus, faFileCircleXmark, faFileInvoice, faHandshake, faUserPen } from "@fortawesome/free-solid-svg-icons";
// All v2 features are enabled by default; an explicit environment list can restrict them.
export const socialFundFeatures = new Set(
  (process.env.VUE_APP_SOCIAL_FUND_V2_FEATURES || "comments,agreement,tires,messages,communications,export")
    .split(",")
    .map((value) => value.trim())
    .filter(Boolean),
);
export const tireOptions = [2, 4, 6, 8, 10, 12, 14, 16];
export const isValidTires = (value) => tireOptions.includes(value);
export const buildSocialFundFilters = (filters) => {
  const params = {};
  const fields = {
    call: "callPeriod.id",
    status: "status",
    a51Resolution: "a51Resolution",
    aidType: "applicationType.code",
    agreementStatus: "agreementStatus",
    finalProof: "hasFinalProof",
    from: "updatedAt[after]",
    to: "updatedAt[before]",
    referenceOrApplicant: "search",
  };
  Object.entries(fields).forEach(([key, parameter]) => {
    if (filters[key]) params[parameter] = filters[key];
  });
  return params;
};
export const normalizeEvaluationAmount = (value) => {
  if (value === null || value === undefined || String(value).trim() === "")
    return null;
  let text = String(value).trim().replace(/\s/g, "");
  if (text.includes(",")) text = text.replace(/\./g, "").replace(",", ".");
  if (!/^\d+(\.\d{1,2})?$/.test(text))
    throw new Error(
      "Introduce un importe positivo con un máximo de dos decimales.",
    );
  return String(Number(text));
};
export const agreementStatusOptions = [
  { value: "pending", label: "Pendiente" },
  { value: "signed_by_applicant", label: "Firmado por el solicitante" },
  { value: "signed_by_director", label: "Firmado por Grupo Andrés" },
  { value: "countersigned", label: "Firmado por ambas partes" },
];
export const finalProofOptions = [
  { value: "true", label: "Con justificante" },
  { value: "false", label: "Sin justificante" },
];
const finalProofIndicators = {
  validated: { icon: faFileCircleCheck, label: "Justificante final validado", tone: "validated" },
  pending: { icon: faFileInvoice, label: "Justificante final pendiente de validar", tone: "pending" },
  rejected: { icon: faFileCircleXmark, label: "Justificante final rechazado", tone: "rejected" },
};
export const finalProofIndicator = (status) => finalProofIndicators[status] ||
  { icon: faFileCircleMinus, label: "Sin justificante final", tone: "missing" };
export const agreementLabel = (item) => item.agreementStatusLabel ||
  agreementStatusOptions.find(option => option.value === item.agreementStatus)?.label || "—";
const agreementIndicators = {
  signed_by_applicant: { icon: faUserPen, tone: "applicant" },
  signed_by_director: { icon: faBuilding, tone: "director" },
  countersigned: { icon: faHandshake, tone: "validated" },
};
export const agreementIndicator = (item) => ({
  icon: faFileCircleMinus,
  tone: "missing",
  ...agreementIndicators[item.agreementStatus],
  label: agreementLabel(item),
});
export const agreementDates = (item) => [
  ["Firma del solicitante", item.agreementSignedByApplicantAt],
  ["Firma de Grupo Andrés", item.agreementCountersignedAt],
].filter(([, value]) => value && Number.isFinite(new Date(value).getTime()))
  .map(([label, value]) => label + ": " + new Date(value).toLocaleString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }))
  .join("\n");
export const collectionItems = (data) =>
  Array.isArray(data) ? data : data?.["hydra:member"] || data?.items || [];
export const apiErrorMessage = async (error, fallback) => {
  let data = error?.response?.data;
  if (typeof Blob !== "undefined" && data instanceof Blob) {
    try {
      data = JSON.parse(await data.text());
    } catch {
      return fallback;
    }
  }
  return data?.error || data?.message || data?.detail || fallback;
};
export const exportFilename = (disposition) => {
  const encoded = disposition?.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  let name;
  try {
    name = encoded
      ? decodeURIComponent(encoded)
      : disposition?.match(/filename="?([^";]+)"?/i)?.[1];
  } catch {
    /* fallback */
  }
  return (
    name?.split(/[\\/]/).pop() ||
    `fondo-social-${new Date().toISOString().slice(0, 10).replace(/-/g, "")}.xlsx`
  );
};
